/* eslint-disable quote-props */
import { Typography, Box, useTheme } from "@mui/material";
import React, { ReactNode, useCallback } from "react";
import { ExternalLinkIcon } from "../../../../../../../components/Icons";
import { VETCOVE_URL } from "../../../../../../../config/params";
import { useVetCoveRedirect } from "../../../../../../../hooks/useVetCoveRedirect";

interface IUrlTileProps {
  title: string;
  description: string;
  url?: string;
  shopUrl: string;
  icon: ReactNode;
  iconBgColor: string;
}

const UrlTile = ({ title, description, url, shopUrl, icon, iconBgColor }: IUrlTileProps) => {
  const theme = useTheme();
  const { handleVetCoveLink } = useVetCoveRedirect();

  const handleClick = useCallback(() => {
    handleVetCoveLink(url, shopUrl || VETCOVE_URL);
  }, [url, shopUrl, handleVetCoveLink]);

  return (
    <Box
      onClick={handleClick}
      className="flex-1 flex justify-between items-center bg-white p-6 rounded-lg border gap-10"
      sx={{
        borderColor: "neutral.light",
        boxShadow: "0px 2px 12px rgba(0, 0, 0, 0.04)",
        textDecoration: "none",
        cursor: "pointer",
        "&:hover": {
          boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.08)",
        },
      }}
    >
      <Box className="flex flex-col gap-2 w-full" sx={{ cursor: "inherit" }}>
        <Typography color="gray.dark" fontSize={18} fontWeight={600} sx={{ cursor: "inherit" }}>
          {title}
        </Typography>
        <Typography color="gray.dark" fontSize={14} sx={{ cursor: "inherit", whiteSpace: "pre-line" }}>
          {description}
        </Typography>
        <Box className="flex items-center gap-2 mt-1" sx={{ cursor: "inherit" }}>
          <ExternalLinkIcon width={16} height={16} color={theme.palette.warning.dark} />
          <Typography color="warning.dark" fontSize={14} sx={{ cursor: "inherit" }}>
            View in Online Pharmacy
          </Typography>
        </Box>
      </Box>
      <Box
        className="flex justify-center items-center w-12 h-12 rounded-full flex-shrink-0"
        sx={{ backgroundColor: iconBgColor, cursor: "inherit" }}
      >
        {icon}
      </Box>
    </Box>
  );
};

export default UrlTile;
